import { assoc, pathOr } from 'ramda'
import HttpCacheAbstractAdapter from './HttpCacheAbstractAdapter'
import strategy from '../dictionary/strategy.json'

/**
 * Cache adaptor for the volatile cache strategy.
 *
 * This strategy should be employed for cached information that will be destroyed when closing the page.
 */
class HttpCacheVolatileAdapter extends HttpCacheAbstractAdapter {
  /**
   * Constructor.
   */
  constructor() {
    super(strategy.volatile)
    this.cacheData = {}
  }

  /**
   * Loads all items for a cache pool.
   *
   * @param {HttpCachePoolConfig} poolConfig
   * @return {Array<HttpCacheItem>}
   */
  load(poolConfig) {
    return pathOr([], [poolConfig.name], this.cacheData)
  }

  /**
   * Saves all items for a cache pool.
   *
   * @param {HttpCachePoolConfig} poolConfig
   * @param {Array<HttpCacheItem>} cacheItems
   * @return {Boolean}
   */
  save(poolConfig, cacheItems) {
    this.cacheData = assoc(poolConfig.name, cacheItems, this.cacheData)
    return true
  }
}

export default HttpCacheVolatileAdapter
